import Form from '../../components/form';

const paymentConfirmation = document.querySelector('.j-payment-confirmation');

if (paymentConfirmation) {
    new Form().init({
        target         : paymentConfirmation,
        successMessage : true,
        successCallback: (responseData) => {
            location.href = responseData.data.payment_transaction.payment_link;
        }
    });
}
